export default __webpack_public_path__ + "static/media/the_venue_4.1ddff666.png";